import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useLazyQuery } from '@apollo/client';

import ReactGA from "react-ga4";

// Apollo
import { QUERY_USER }  from '../../utils/queries';
// Redux
import { SET_USER, LOGGED_IN_USER } from '../../utils/actions';

import Auth from "../../utils/auth";


import './Nav.css';

const isPublicEnvironment = process.env.REACT_APP_ENVIRONMENT === 'public';

function Nav() {
  const dispatch = useDispatch();

  const loggedInUser = useSelector(state => state.loggedInUser);

  const [getUser, { data: userData, error: userError }] = useLazyQuery(QUERY_USER);

  const [userCheckPending, setUserCheckPending] = useState(null);
  const [loggedIn, setLoggedIn] = useState(false);
  const [isAdmin, setIsAdmin] = useState(null);

  const location = useLocation();

  useEffect(() => {
    console.debug({ hitType: 'pageview', page: location.pathname + location.search });
    if (isPublicEnvironment) {
        ReactGA.send({ hitType: 'pageview', page: location.pathname + location.search });
    }
  }, [location]);

  useEffect(() => {
    if (userCheckPending === null) {
      if (loggedInUser || Auth.loggedIn()) {
        setUserCheckPending(true);
        getUser().then(() => console.debug('getUser DONE'));
      } else {
        setLoggedIn(false);
      }
    }
  }, [getUser, setUserCheckPending, userCheckPending, loggedInUser]);

  useEffect(() => {
    if (userError) {
      console.error(userError);
      setLoggedIn(false);
      setUserCheckPending(false);
    } else if (userData) {
      dispatch({ type: SET_USER, user: userData.user });
      if (userData.user === null) {
        Auth.removeToken();
      }
      setIsAdmin(userData.user && userData.user.admin);
      setLoggedIn(userData.user !== null);
      setUserCheckPending(false);
    }
  }, [userData, userError, dispatch, setLoggedIn, setUserCheckPending]);

  function doLogout() {
    setLoggedIn(false);
    dispatch({ type: LOGGED_IN_USER, user: null });
    Auth.logout();
  }

  function showNavigation() {
    return (
      <ul className="flex-row me-7">
        {isAdmin ? <li>
                      <Link to="/our-products/skin-care">
                        Skin Care Products
                      </Link>
                    </li>
                  : null}
        <li>
          <a href="https://oshikem.blogspot.com/">
            Blog
          </a>
        </li>

        {loggedIn ?
          (<>
              <li>
                <Link to="/orderHistory">
                  Order History
                </Link>
              </li>
              {
                isAdmin ?
                  <li>
                    <Link to="/admin">
                      Admin
                    </Link>
                  </li> : null
                }
              <li>
                {/* this is not using the Link component to logout or user and then refresh the application to the start */}
                <a href="/" onClick={doLogout}>
                  Logout
                </a>
              </li>
            </>) :
          (<>
              {/*<li>
                <Link to="/login">
                  Login
                </Link>
              </li>
              <li>
                <Link to="/signup">
                  Signup
                </Link>
              </li>*/}
            </>) }
      </ul>
    );
  }

  return (
    <header>
      <nav>
        {userCheckPending ? null : showNavigation()}
      </nav>
      <h1>
        <Link to="/">OSHIKEM</Link>
      </h1>
    </header>
  );
}

export default Nav;
